import { jwtDecode, JwtPayload } from "jwt-decode";
import Cookies from "js-cookie";

interface GloboIdTokenPayload extends JwtPayload {
  globoId: string;
  userName: string;
}

export const setGloboIdFromCookie = () => {
  const globoIdToken = Cookies.get("GLOBO_ID");

  if (!globoIdToken) {
    return;
  }

  const data = jwtDecode<GloboIdTokenPayload>(globoIdToken);

  localStorage.setItem("globoId", data.globoId);
};
